import AutomationsPage from '@/modules/automations/pages/AutomationsPage'
import ExportsTab from '@/modules/automations/pages/ExportsTab'
import ImportsTab from '@/modules/automations/pages/ImportsTab'
import ExportFormPage from '@/modules/automations/pages/ExportFormPage'
import ImportFormPage from '@/modules/automations/pages/ImportFormPage'
import ImportRunHistoryPage from '@/modules/automations/pages/ImportRunHistoryPage'
import ImportRunHistorySyncs from '@/modules/automations/components/ImportRunHistorySyncs'
import ImportRunHistoryTasks from '@/modules/automations/components/ImportRunHistoryTasks'

export default [
  {
    name: 'Automations',
    path: '/automations',
    component: AutomationsPage,
    meta: {
      auth: ['viewAutomation'],
      title: 'Automations_Title'
    },
    children: [
      {
        name: 'AutomationImports',
        path: 'imports',
        component: ImportsTab,
        meta: {
          auth: ['viewAutomation']
        }
      },
      {
        name: 'AutomationExports',
        path: 'exports',
        component: ExportsTab,
        meta: {
          auth: ['viewAutomation']
        }
      }
    ]
  },
  {
    name: 'AutomationExportView',
    path: '/automations/export/view',
    component: ExportFormPage,
    props: { readonly: true },
    project: true,
    meta: {
      auth: ['viewAutomation']
    }
  },
  {
    name: 'AutomationExportCreate',
    path: '/automations/export/create',
    component: ExportFormPage,
    props: { readonly: false },
    project: true,
    meta: {
      auth: ['manageAutomation']
    }
  },
  {
    name: 'AutomationExportUpdate',
    path: '/automations/export/update',
    component: ExportFormPage,
    props: { readonly: false },
    project: true,
    meta: {
      auth: ['manageAutomation']
    }
  },
  {
    name: 'AutomationImportView',
    path: '/automations/import/view',
    component: ImportFormPage,
    props: { readonly: true },
    project: true,
    meta: {
      auth: ['manageAutomation']
    }
  },
  {
    name: 'AutomationImportCreate',
    path: '/automations/import/create',
    component: ImportFormPage,
    props: { readonly: false },
    project: true,
    meta: {
      auth: ['manageAutomation']
    }
  },
  {
    name: 'AutomationImportUpdate',
    path: '/automations/import/update',
    component: ImportFormPage,
    props: { readonly: false },
    project: true,
    meta: {
      auth: ['manageAutomation']
    }
  },
  {
    path: '/automations/import/run-history',
    component: ImportRunHistoryPage,
    project: true,
    meta: {
      auth: ['viewAutomation']
    },
    children: [
      {
        name: 'AutomationImportRunHistorySyncs',
        path: 'syncs',
        component: ImportRunHistorySyncs,
        meta: {
          auth: ['viewAutomation']
        }
      },
      {
        name: 'AutomationImportRunHistoryTasks',
        path: 'tasks',
        component: ImportRunHistoryTasks,
        meta: {
          auth: ['viewAutomation']
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/automations/router/index.js